import HighlightPhraseFilter from './HighlightPhraseFilter';
import prettyPhoneNumber from './prettyPhoneNumber';
//UCEPRODENG-746 Phone Number valid format
import prettyPhoneNumberPSA from './prettyPhoneNumberPSA';

export default angular.module('edge.platform.filters', [
    'edge.platform.l10n'
])
    .filter('highlightPhrase', HighlightPhraseFilter)
    .filter('gwPrettyPhoneNumber', prettyPhoneNumber)
     //UCEPRODENG-746, 776 Phone Number valid format
    .filter('gwPrettyPhoneNumberPSA', prettyPhoneNumberPSA);
